import * as mutationTypes from './mutationTypes'

export default {

  [ mutationTypes.SET_CLOUD_CANNON_CONTENT_LOADING ] (state, cloudCannonContentLoading) {
    state.cloudCannonContentLoading = cloudCannonContentLoading
  },

  [ mutationTypes.SET_CLOUD_CANNON_CONTENT ] (state, cloudCannonPayload = {}) {
    state.cloudCannonContent = cloudCannonPayload
  },

  [ mutationTypes.SET_CLOUD_CANNON_FOOTER_CONTENT_LOADING ] (state, cloudCannonFooterContentLoading) {
    state.cloudCannonFooterContentLoading = cloudCannonFooterContentLoading
  },

  [ mutationTypes.SET_CLOUD_CANNON_FOOTER_CONTENT ] (state, cloudCannonPayload = {}) {
    state.cloudCannonFooterContent = cloudCannonPayload
  }
}
